import { Component, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { collapseGroupDropdown, initCollapseDropdownFilter } from '@app/helpers/scripts';
import { IDataGrouped } from '@app/interfaces/idata-grouped';
import { PlatformService } from '@app/services/platform.service';

@Component({
  selector: 'form-group-checkbox-multi-level',
  templateUrl: './form-group-checkbox-multi-level.component.html',
  styleUrls: ['./form-group-checkbox-multi-level.component.css']
})
export class FormGroupCheckboxMultiLevelComponent {

  @Input() control: FormControl;
  @Input() controlText: string = ''
  @Input() controlId: string = ''
  @Input() controlArray: FormArray;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() footer: string = '';
  @Input() messageRequired: string = '';
  @Input() placeholderSearch: string = '';
  @Input() showValuesOnPlaceholder: boolean = false;
  @Input() dataSelect: Array<IDataGrouped> = [];
  @Input() textSelectAllGroup: string = '';
  @Input() size: 'lg' | 'default' = 'default';
  @Input() selectionCountAllowed: number = 0;
  @Input() popoverContent: string = '';


  public countSelectedValues: number = 0;
  public placeholderTextSelected: string = '';
  private _indexElementDisabled: number = -1; // permanent disabled


  constructor(
    private platformService: PlatformService) {
  }

  ngAfterViewInit() {

    this.initComponent();
  }

  initComponent() {
    if (this.platformService.isPlatformBrowser) {
      initCollapseDropdownFilter(this.id);
      collapseGroupDropdown();
    }


    if (this.showValuesOnPlaceholder) {
      this.controlArray.valueChanges.subscribe(() => {
        this.getCountSelectedValues();
      })
    }

  }

  getCountSelectedValues() {

    this.countSelectedValues = this.controlArray.controls
      .map((faParent: FormArray) => faParent.controls.filter((faControlChild: FormControl) => faControlChild.value === true).length)
      .reduce((acc, count) => acc + count, 0);
  }

  onChangeCheckboxAll(event: any, indexParent: number) {

    const faParent = this.controlArray.at(indexParent) as FormArray;

    faParent.controls.forEach((e: FormControl) => e.setValue(event.target.checked === true, { emitEvent: false }));

    this.disableUnselectedItems();

    this.controlArray.updateValueAndValidity();

  }

  onChangeCheckbox(event: any, indexParent: number) {

    this.disableUnselectedItems();

    const checkSelectAll = document.getElementById(`${this.id}-all-${indexParent}`) as HTMLInputElement;

    const faParent = this.controlArray.at(indexParent) as FormArray;

    const lenghtTrue = faParent.controls.filter((e: FormControl) => e.value === true).length;

    checkSelectAll.checked = lenghtTrue === faParent.controls.length;
  }

  uncheckOptionAll() {

    for (let indexParent = 0; indexParent < this.controlArray.controls.length; indexParent++) {

      const faParent = this.controlArray.at(indexParent) as FormArray;

      for (let indexChild = 0; indexChild < faParent.controls.length; indexChild++) {

        const faControlChild = faParent.at(indexChild) as FormControl;

        faControlChild.setValue(false, { emitEvent: false });
      }
    }

    this.disableUnselectedItems();
  }

  onRemoveOption(event: MouseEvent, indexParent: number, indexChild: number) {

    event.stopPropagation();

    const faParent = this.controlArray.at(indexParent) as FormArray;

    faParent.at(indexChild).setValue(false);

    const checkSelectAll = document.getElementById(`${this.id}-all-${indexParent}`) as HTMLInputElement;

    const lenghtTrue = faParent.controls.filter((e: FormControl) => e.value === true).length;

    checkSelectAll.checked = lenghtTrue === faParent.controls.length;
  }


  disableUnselectedItems() {

    // revisar

    if (this.selectionCountAllowed === 0)
      return;

    let arrSelected = [];

    for (let indexParent = 0; indexParent < this.controlArray.controls.length; indexParent++) {

      const faParent = this.controlArray.at(indexParent) as FormArray;

      for (let indexChild = 0; indexChild < faParent.controls.length; indexChild++) {

        const faControlChild = faParent.at(indexChild) as FormControl;

        if (faControlChild.value === true) {
          arrSelected.push(this.dataSelect[indexParent].items[indexChild].child)
        }
      }
    }

    switch (arrSelected.length || 0) {
      case 0:
        this.placeholderTextSelected = '';
        break;

      case 1:
        this.placeholderTextSelected = arrSelected[0].text;
        break;

      default:
        this.placeholderTextSelected = 'Múltiples opciones seleccionadas';
        break;
    }

    if (arrSelected.length >= this.selectionCountAllowed) {
      this.controlArray.controls
        .filter(e => e.value === false)
        .forEach(e => e.disable({ emitEvent: false }));
      return;
    }

    for (let indexParent = 0; indexParent < this.controlArray.controls.length; indexParent++) {

      const faParent = this.controlArray.at(indexParent) as FormArray;

      for (let indexChild = 0; indexChild < faParent.controls.length; indexChild++) {

        const faControlChild = faParent.at(indexChild) as FormControl;

        if (faControlChild.value === false) {
          faControlChild.enable({ emitEvent: false })
        }
      }
    }

    if (this.indexElementDisabled !== -1) {
      this.controlArray.at(this.indexElementDisabled).disable({ emitEvent: false });
    }

  }

  public get indexElementDisabled(): number {
    return this._indexElementDisabled;
  }

  public set indexElementDisabled(value: number) {
    this._indexElementDisabled = value;
  }
}